module.exports = __webpack_public_path__ + "img/candanswericon.e9c102c3.svg";